import BrokerPulsCheckActions from './BrokerPulsCheckActions.component';

export default BrokerPulsCheckActions;
